var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 19L1 31M1 29h22c0-2.21-1.79-4-4-4h-5c0-2.21-1.79-4-4-4H1M9 25L14 25M21.965 2.201c.265.292.64.46 1.034.46s.77-.168 1.034-.46l.667-.741c.395-.437 1.023-.579 1.567-.353.545.226.888.77.858 1.358l-.05.996c-.022.396.125.781.405 1.061.28.28.666.428 1.061.406l.996-.052c.589-.029 1.132.316 1.357.86.225.544.084 1.171-.353 1.567l-.74.666c-.293.264-.46.64-.46 1.034 0 .395.167.77.46 1.034l.74.667c.437.395.579 1.022.354 1.567-.226.544-.77.888-1.358.858l-.996-.05c-.395-.022-.78.125-1.06.405s-.428.666-.406 1.061l.05.996c.03.589-.313 1.133-.858 1.359-.544.225-1.172.084-1.567-.353l-.667-.742c-.264-.292-.64-.458-1.034-.458s-.77.166-1.034.458l-.666.742c-.396.437-1.023.578-1.568.353-.544-.226-.888-.77-.858-1.359l.051-.996c.022-.395-.126-.78-.406-1.06s-.665-.428-1.06-.406l-.997.05c-.587.026-1.127-.32-1.35-.863-.223-.544-.08-1.17.356-1.563l.74-.667c.293-.264.46-.64.46-1.034s-.167-.77-.46-1.034l-.74-.667c-.437-.395-.578-1.022-.353-1.567.225-.544.768-.888 1.357-.86l.996.053c.395.022.78-.126 1.06-.406s.428-.666.406-1.061l-.05-.996c-.021-.582.322-1.116.86-1.338.539-.223 1.159-.087 1.554.34l.668.735z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 9,
    r: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.491d3dcacbf783f347d24eac784852e5.svg";
export { ForwardRef as ReactComponent };